// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujAlerteColonne.js
//  l'alerte quand la colonne category refuse les catégories de tâches
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export function SujAlerteColonne({ tachesCfg }) {
  return (
    <>
      {/* Alerte : la colonne category refuse les catégories de tâches */}
      {tachesCfg.actif && tachesCfg.colonne_ok === false && (
        <div style={{ background: THEME.redDim, border: `1px solid ${THEME.red}`, borderRadius: 10, padding: "12px 16px" }}>
          <div style={{ color: THEME.red, fontSize: 13, fontWeight: 700, marginBottom: 6 }}>⚠️ Création de tâches bloquée</div>
          <div style={{ color: THEME.text, fontSize: 12, lineHeight: 1.5, marginBottom: 8 }}>
            La colonne <code>project_tasks.category</code> n'accepte pas encore les catégories du module.
            Exécute ce SQL dans ta base puis redémarre le backend :
          </div>
          {tachesCfg.alter_sql && (
            <div style={{ background: THEME.bg, borderRadius: 6, padding: "8px 12px", color: THEME.gold, fontSize: 11, fontFamily: "'Courier New', monospace", wordBreak: "break-all", marginBottom: 8 }}>
              {tachesCfg.alter_sql}
            </div>
          )}
          {tachesCfg.alter_sql && (
            <button onClick={() => navigator.clipboard && navigator.clipboard.writeText(tachesCfg.alter_sql)}
              style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, color: THEME.text, borderRadius: 6, padding: "5px 12px", cursor: "pointer", fontSize: 11 }}>📋 Copier le SQL</button>
          )}
        </div>
      )}
    </>
  );
}
